import React from "react";
import { TabComponents } from "../../components/Vacataire/TabComponents";

const VacataireView: React.FC = () => {
  return <TabComponents />;
};

export default VacataireView;
